import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import DashboardLayout from './layouts/DashboardLayout';
import Dashboard from './pages/Dashboard';
import Workflow from './pages/Workflow';
import HistoryTable from './pages/History';
import ExpenseNotes from './pages/ExpenseNotes';
import Rebilling from './pages/Rebilling';
import OneDrivePurchases from './pages/OneDrivePurchases';
import BankStatements from './pages/BankStatements';
import Settings from './pages/Settings';
import { MonthProvider } from './context/MonthContext';
import ErrorBoundary from './components/ErrorBoundary';
import './index.css';

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('token'));

  useEffect(() => {
    document.title = `Facturation (v${__APP_VERSION__})`;
  }, []);

  return (
    <ErrorBoundary>
      <MonthProvider>
        <BrowserRouter>
        <Routes>
          <Route 
            path="/login" 
            element={!isAuthenticated ? <Login setAuth={setIsAuthenticated} /> : <Navigate to="/" />} 
          />
          
          <Route 
            path="/" 
            element={isAuthenticated ? <DashboardLayout setAuth={setIsAuthenticated} /> : <Navigate to="/login" />}
          >
            <Route index element={<Dashboard />} />
            <Route path="workflow" element={<Workflow />} />
            <Route path="history" element={<HistoryTable />} />
            <Route path="expense-notes" element={<ExpenseNotes />} />
            <Route path="rebilling" element={<Rebilling />} />
            <Route path="onedrive" element={<OneDrivePurchases />} />
            <Route path="statements" element={<BankStatements />} />
            <Route path="settings" element={<Settings />} />
          </Route>
        </Routes>
        </BrowserRouter>
      </MonthProvider>
    </ErrorBoundary>
  );
};

export default App;
